import update from 'immutability-helper'

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'channels' implicitly has an 'any' type.
export default function updateChannel(channels, channelId, values) {
  if (!channels) {
    console.error('[updateChannel] No channels were provided')
    return null
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
  const channelIndex = channels.findIndex((el) => {
    return el.serviceId === channelId || el.id === channelId
  })

  if (channelIndex < 0) {
    console.error(`[updateChannel] Channel ${channelId} could not be found.`)
    return null
  }

  const channel = channels[channelIndex]
  if (
    values?.updatedAt &&
    new Date(channel.updatedAt) >= new Date(values.updatedAt)
  ) {
    return null
  }

  const commands = {}
  Object.keys(values).forEach((key) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    commands[key] = { $set: values[key] }
  })

  return update(channels, {
    [channelIndex]: commands,
  })
}
